import { Injectable } from '@angular/core';
import { LocationInterface } from 'app/models/location.model';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';

@Injectable({
  providedIn: 'root',
})
export class LocationDataTransformPost extends DataTransformAbstractPost {
  transform(location: LocationInterface): LocationInterface {
    // The BE expects customers as a plain list of ids.
    location.customers = (location.customers || []).map((v) => v.id) as any;
    return location;
  }
}
